import { Remarkable } from 'remarkable';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { default as Emoji } from 'remarkable-emoji';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
declare module 'remarkable-emoji';

/**
 * Hook that exposes a method for parsing Markdown
 * content to HTML.
 * To render the HTML, use the <Markdown> Component,
 * this will sanitize your content
 */
function useMarkdown(): (richText?: string) => string {
  const md = new Remarkable();
  md.use(Emoji);
  return (richText?: string) => md.render(richText ?? '');
}

export { useMarkdown };
